export default __webpack_public_path__ + "static/media/store-logos.a906faef.svg";